import { render, staticRenderFns } from "./AdminUpdateLawCollections.vue?vue&type=template&id=73301b61"
import script from "./AdminUpdateLawCollections.vue?vue&type=script&lang=js"
export * from "./AdminUpdateLawCollections.vue?vue&type=script&lang=js"
import style0 from "./AdminUpdateLawCollections.vue?vue&type=style&index=0&id=73301b61&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73301b61')) {
      api.createRecord('73301b61', component.options)
    } else {
      api.reload('73301b61', component.options)
    }
    module.hot.accept("./AdminUpdateLawCollections.vue?vue&type=template&id=73301b61", function () {
      api.rerender('73301b61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminUpdateLawCollections.vue"
export default component.exports